import querystring from 'querystring';
import {formatRoute} from 'react-router-named-routes';
import {legacyEzRailsDomain as ezRailsDomain} from './components/Environment';

export const ABOUT_EZDISPATCH_WHENEVER_URL = `${ezRailsDomain}/company/catering-growth-platform/delivery-solutions/ezdispatch/`;
export const ABOUT_EZDISPATCH_URL = `${ezRailsDomain}/company/catering-growth-platform/delivery-solutions/ezdispatch/`;
export const ABOUT_EZORDERING_URL = `${ezRailsDomain}/company/grow-catering-business/lp/ezordering/`;
export const ABOUT_RELIABILITY_ROCKSTARS = `${ezRailsDomain}/company/grow-catering-business/reliability-rockstars/`;
export const ACH_FORM_URL = `${ezRailsDomain}/company/grow-catering-business/direct-deposit-signup/`;
export const ACCURACY_AND_DELIVERY_TRACKING_LEARN_MORE_URL =
  'https://catering.ezcater.com/en/help/operational-best-practices';
export const ADD_NEW_CATERING_PARTNER_ACCOUNT_PATH =
  '/settings/users/catering-partner-accounts/new';
export const ADMIN_URL = `${ezRailsDomain}/admin`;
export const APP_SITE_ASSOCIATION_PATH = '/apple-app-site-association';
export const BULK_EDIT_STORE_SETTINGS_PATH = '/settings/stores/bulk-edit-store-settings';
export const CLUB_SODA_PATH = '/relish';
export const MEAL_PROGRAM_PATH = '/mealprogram';
export const DASHBOARD_URL = `${ezRailsDomain}/ez_manage/dashboard`;
export const DRAFT_INDEX_PATH = '/drafts';
export const QUOTE_INDEX_PATH = '/quotes';
export const LEGACY_DRAFT_AND_QUOTE_INDEX_PATH = '/draftsandquotes';
export const EDIT_DAILY_CAPACITY_PATH = '/settings/store/:storeId/daily-capacity/edit';
export const EDIT_STORE_DETAILS_PATH = '/settings/store/:storeId/edit';
export const EDIT_TEMPORARY_CLOSURES_PATH = '/settings/store/:storeId/temporary-closures/edit';
export const EDIT_OPERATING_SCHEDULES_PATH = '/settings/store/:storeId/operating-hours/edit';
export const EDIT_LEAD_TIME_PATH = '/settings/store/:storeId/lead-time/edit';
export const EDIT_HOLIDAY_CLOSURES_PATH = '/settings/store/:storeId/holiday-closures/edit';
export const EDIT_POLICIES_PATH = '/settings/store/:storeId/policies/edit';
export const ADD_NEW_STORE_PATH = '/settings/add-new-store';
export const ADD_NEW_STORE_LISTING_INFORMATION_PATH = '/settings/add-new-store/listing-information';
export const ADD_NEW_STORE_ACH_FORM_PATH = '/settings/add-new-store/ach-form';
export const DELIVERY_PERFORMANCE_REPORTING_PATH = '/delivery-reporting';
export const EZ_DISPATCH_PREFERENCES_PATH = '/dispatch/preferences';
export const EZ_ORDERING_MARKETING_PATH = '/ezordering';
export const DIRECT_ENTRY_PATH = '/direct_entry/:orderId';
export const LEGACY_CLUB_SODA_PATH = '/clubsoda';
export const ONBOARDING_PATH = '/onboarding';
export const OPERATIONAL_METRICS_PATH = '/operational-metrics';
export const OPERATIONAL_METRICS_STORE_PATH = '/operational-metrics/store/:catererId';
export const OPERATIONAL_METRICS_HELP_CENTER_PATH = '/operational-metrics/help-center';
export const OPERATIONAL_METRICS_LEARN_MORE_PATH =
  'https://catering.ezcater.io/en/articles/13974759-operational-metrics';
export const ORDER_ENTRY_NEW_PATH = '/order_entry/new';
export const ORDER_ENTRY_MODIFICATION_PATH = '/order_entry/:orderId/modification';
export const ORDER_ENTRY_PATH = '/order_entry/:orderId';
export const ORDER_ENTRY_REVIEW_PATH = '/order_entry/:orderId/review';
export const DRAFT_AND_QUOTE_INDEX_PATH = '/unplaced';
export const ORDER_CANCELLED_PATH = '/canceled';
export const ORDER_COMPLETED_PATH = '/completed';
export const ORDER_REJECTED_PATH = '/rejected';
export const ORDER_INDEX_PATH = '/orders';
export const ORDER_DETAILS_PATH = `/orders/:orderId`;
export const ORDER_MESSAGE_PATH = `/orders/:orderId/message`;
export const PAYMENT_DETAILS_PATH = '/payments/:paymentId';
export const PAYMENTS_PATH = '/payments';
export const PERFORMANCE_PATH = '/performance';
export const PERFORMANCE_STORE_PATH = '/performance/:storeId';
export const PERFORMANCE_GROUP_PATH = '/performance/group/:groupId';
export const PERFORMANCE_METRICS_PATH = '/performance-metrics';
export const PROMOTIONS_PATH = '/promotions';
export const PROMOTION_NEW_PATH = '/promotions/new';
export const PROMOTION_DETAILS_PATH = `/promotions/:promoId`;
export const promoDetailsPath = promoId => formatRoute(PROMOTION_DETAILS_PATH, {promoId});
export const PROMO_DETAIL_REDEMPTIONS_PATH = '/promotions/:promoId/redemptions';
export const promoDetailRedemptionsPath = promoId =>
  formatRoute(PROMO_DETAIL_REDEMPTIONS_PATH, {promoId});
export const QUOTES_REVIEW_PATH = '/quotes/:orderId/review';
export const PRIVACY_POLICY_URL = `${ezRailsDomain}/privacy_policy`;
export const RANKINGS_URL = `${ezRailsDomain}/caterer_portal/rankings`;
export const RANKINGS_PATH = '/rankings';
export const RANKINGS_STORE_PATH = '/rankings/stores/:storeId';
export const MARK_ORDER_READY_FOR_PICKUP_PATH = '/mark-order-ready-for-pickup/:orderId';
export const RELIABILITY_ROCKSTAR_PROGRAM_VIDEO = 'https://ezcater.wistia.com/medias/my4q61zejy';
export const REPORTS_URL = `${ezRailsDomain}/ez_manage/reports`;
export const NEW_REPORTS_URL = `${ezRailsDomain}/ez_manage/reports/new`;
export const REVIEWS_PATH = '/reviews';
export const REVIEWS_URL = `${ezRailsDomain}/ez_manage/reviews`;
export const SETTINGS_ACCOUNT_PATH = '/settings/account';
export const SETTINGS_BULK_EDIT_DAILY_CAPACITY_PATH = '/settings/stores/daily-capacity/edit';
export const SETTINGS_BULK_EDIT_HOLIDAY_CLOSURES_PATH = '/settings/stores/holiday-closures/edit';
export const SETTINGS_BULK_EDIT_LEAD_TIMES_PATH = '/settings/stores/lead-times/edit';
export const SETTINGS_BULK_EDIT_OPERATING_SCHEDULES_PATH = '/settings/stores/operating-hours/edit';
export const SETTINGS_BULK_EDIT_TEMPORARY_CLOSURES_PATH =
  '/settings/stores/temporary-closures/edit';
export const SETTINGS_STORE_PATH = '/settings/stores';
export const SETTINGS_USERS_PATH = '/settings/users';
export const SETTINGS_EDIT_ACCOUNT_ACCESS_PATH = '/settings/user/:accountId/access/edit';
export const SETTINGS_EDIT_ACCOUNT_CONTACT_METHODS_PATH =
  '/settings/user/:accountId/notifications/edit/contact-methods';
export const SETTINGS_EDIT_ACCOUNT_DEMOGRAPHIC_DATA_PATH = '/settings/edit/demographic-data';
export const SETTINGS_EDIT_ACCOUNT_NOTIFICATIONS_PATH =
  '/settings/user/:accountId/notifications/edit';
export const SETTINGS_EDIT_ACCOUNT_PERMISSIONS_PATH = '/settings/user/:accountId/permissions/edit';
export const SETTINGS_SERVICES_PATH = '/settings/services';
export const SETTINGS_STORE_DETAILS_PATH = '/settings/store/:storeId';
export const SETTINGS_PERSONAL_STORE_GROUP_PATH = '/settings/store-group/:groupId';
export const SETTINGS_PERSONAL_STORE_GROUPS_PATH = '/settings/store-groups';
export const SETTINGS_PAYMENT = '/settings/payment';
export const SETTINGS_UPDATE_CONTACT_PATH =
  'https://ezcaterforms.formstack.com/forms/partnerportal_account_updates';
export const SETTINGS_UPDATE_CUTOFF_PATH =
  'https://ezcaterforms.formstack.com/forms/partnerportal_account_updates';
export const SETTINGS_UPDATE_DELIVERY_PATH =
  'https://ezcaterforms.formstack.com/forms/partnerportal_account_updates';
export const SETTINGS_UPDATE_FORM_PATH =
  'https://ezcaterforms.formstack.com/forms/partnerportal_account_updates';
export const SETTINGS_UPDATE_HOURS_PATH =
  'https://ezcaterforms.formstack.com/forms/partnerportal_account_updates';
export const SETTINGS_UPDATE_STORE_CONTACTS_PATH =
  'https://ezcaterforms.formstack.com/forms/partnerportal_account_updates';
export const SETTINGS_UPDATE_TEMPORARY_CLOSURES_PATH =
  'https://ezcaterforms.formstack.com/forms/partnerportal_account_updates';
export const SIGN_IN_URL = `${ezRailsDomain}/caterer_portal/sign_in`;
export const SIGN_UP_URL = `${ezRailsDomain}/company/grow-catering-business/#caterer-signup-form`;
export const SMS_TERMS = `${ezRailsDomain}/sms-terms`;
export const SUBWAY_URL = '/subway';
export const TERMS_CONDITIONS_CATERERS_PATH = `${ezRailsDomain}/terms_and_conditions_caterers`;
export const TRAINING_RESOURCES_PATH = '/training_resources';
export const RELIABILITY_ROCKSTAR_PATH = '/reliability_rockstar';
export const HEALTH_CHECK_PATH = '/health_check';
export const QUOTE_OR_ORDER_PATH = '/quote_or_order/:quoteOrOrderId';
export const INTEGRATION_CREDENTIALS_PATH = `/settings/integration-credentials`;
export const MENU_PATH = '/menus';
export const MENU_STORE_PATH = '/menus/:storeId';
export const MENU_PERFORMANCE_PATH = '/menu-performance';
export const TAX_INFO_SETTINGS = '/tax_info_settings';
export const PAYMENT_INFO_SETTINGS = '/payment_info_settings';
export const WORKRAMP_PATH = '/workramp';
export const MARKETING_TOOLS_PATH = '/marketing-tools';
export const SPONSORED_LISTING_CAMPAIGN_DETAILS_PATH =
  '/marketing-tools/sponsored-listing-campaign/:campaignGroupId';
export const SPONSORED_LISTING_CAMPAIGN_NEW_PATH =
  '/marketing-tools/sponsored-listing-campaign/new';
export const SPONSORED_LISTING_LANDING_PATH = '/marketing-tools/sponsored-listings';
export const SPONSORED_LISTING_CAMPAIGNS_PATH = '/marketing-tools/sponsored-listing-campaigns';
export const SPONSORED_LISTING_CAMPAIGN_GROUP_EDIT_PATH =
  '/marketing-tools/sponsored-listing-campaign-group/edit/:campaignGroupId';
export const MARKETING_ACTIVITY_PATH = '/marketing-tools/activity';
export const PROMO_NEW_PATH = '/marketing-tools/promos/new';
export const PROMOS_PATH = '/marketing-tools/promos';
export const PROMO_DETAILS_PATH = '/marketing-tools/promos/:promoId';

// Delivery Management Paths are on a separate subdomain use ${deliveryManagementUiHost}/path to access
export const DELIVERY_MANAGEMENT_DELIVERIES_PATH = '/deliveries';
export const DELIVERY_MANAGEMENT_DRIVERS_PATH = '/drivers';
export const DELIVERY_MANAGEMENT_REPORTING_PATH = '/reporting';
export const DELIVERY_MANAGEMENT_EDIT_DRIVER_PATH = '/drivers/:id/edit';
export const DELIVERY_MANAGEMENT_NEW_DRIVER_PATH = '/drivers/new';

export const storeSettingsPath = (totalCount, storeId) =>
  totalCount > 1 ? formatRoute(SETTINGS_STORE_DETAILS_PATH, storeId) : SETTINGS_STORE_PATH;

export const specificStoreSettingsPath = (
  totalCount,
  storeId,
  path = SETTINGS_STORE_DETAILS_PATH
) => (totalCount > 1 ? SETTINGS_STORE_PATH : formatRoute(path, {storeId}));

export const orderEntryReviewPath = orderId => formatRoute(ORDER_ENTRY_REVIEW_PATH, {orderId});

export const orderEntryPath = orderId => formatRoute(ORDER_ENTRY_PATH, {orderId});

export const orderEntryModificationPath = orderId =>
  formatRoute(ORDER_ENTRY_MODIFICATION_PATH, {orderId});

export const quoteReviewPath = orderId => formatRoute(QUOTES_REVIEW_PATH, {orderId});

export const orderDetailsPath = orderId => formatRoute(ORDER_DETAILS_PATH, {orderId});

export const orderMessagePath = orderId => formatRoute(ORDER_MESSAGE_PATH, {orderId});
export const signInUrlWithDestUrl = destUrl =>
  `${SIGN_IN_URL}?${querystring.stringify({dest_url: destUrl})}`;

export const printOrderPath = (orderId, args) =>
  `${ezRailsDomain}/api/caterer/order_details/${orderId}.html?${querystring.stringify(args)}`;

export const downloadOrderPDFPath = (orderId, args) =>
  `${ezRailsDomain}/api/caterer/order_details/${orderId}.pdf?${querystring.stringify(args)}`;

export const GET_HELP_URL = 'https://catering.ezcater.io/en/articles/14037626-contact-support';
export const HELP_CENTER_URL = 'https://catering.ezcater.io/';
export const OPERATIONAL_ACCOUNTABILITY_URL =
  'https://catering.ezcater.io/en/articles/13974802-operational-accountability';

export const RELIABILITY_ROCKSTAR_PROGRAM_INFO =
  'https://catering.ezcater.io/en/articles/13974774-reliability-rockstar';
export const SALES_TAX_LEARN_MORE_URL = 'https://www.ezcater.com/company/tax-remittance/';
export const TRAINING_RESOURCES_URL = 'https://catering.ezcater.io/en/';
export const APPLE_STORE_LINK =
  'https://apps.apple.com/us/app/ezmanage-catering-management/id1439463312';
export const GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=com.ezcater.ezmanage&hl=en_US';

const PROMO_SERVICE_IMAGE_DOWNLOAD_PATH = '/promo_image_zips/:promoId';
const promoServiceUrl = (baseUrl, relativePath) => `${baseUrl}${relativePath}`;

export const promoImageDownloadPath = (baseUrl, promoId) =>
  promoServiceUrl(baseUrl, formatRoute(PROMO_SERVICE_IMAGE_DOWNLOAD_PATH, {promoId}));

export const shortlinkUrl = (shortlinkHost, shortlinkSlug) => `${shortlinkHost}/${shortlinkSlug}`;
export const getShortlinkFromSlug = (shortlinkHost, slug) =>
  shortlinkUrl(shortlinkHost, slug).replace(/^https?:\/\//, '');
